export default __webpack_public_path__ + "static/media/comunicacion.fdfb0d3f.png";